import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    useTheme,
} from "@mui/material";
import { Typography } from "@foodpilot/foods";
import { useEffect, useState } from "react";
import { useRecalculatePost } from "src/api/client-api/post/useRecalculatePost";
import { useTranslation } from "react-i18next";
import { Post } from "src/api/client-api/post/postSchema";

type StalePostRecalculateModalProps = {
    post?: Post;
};

export const StalePostRecalculateModal = (props: StalePostRecalculateModalProps) => {
    const { post } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const [isAcknowledged, setIsAcknowledged] = useState(false);
    const recalculatePost = useRecalculatePost();

    useEffect(() => {
        setIsAcknowledged(false);
    }, [post?.id, post?.isStale]);

    const isOpen = post?.isStale === true && !isAcknowledged;

    const handleOkClick = () => {
        if (post === undefined) return;

        recalculatePost.mutate(
            { postId: post.id },
            {
                onSuccess: () => setIsAcknowledged(true),
            },
        );
    };

    return (
        <Dialog open={isOpen} fullWidth maxWidth="xs" disableEscapeKeyDown>
            <DialogTitle padding={0}>
                <Stack padding={theme.spacing(2)} gap={theme.spacing(2)}>
                    <Typography variant="h3">
                        {t("questionnaire.stale.modal.title", "Your questionnaire calculation data might be outdated.")}
                    </Typography>
                    <Typography variant="body">
                        {t(
                            "questionnaire.stale.modal.body",
                            "Your questionnaire was updated with new version. Calculation will be triggered now.",
                        )}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent />
            <DialogActions
                sx={{
                    padding: 0,
                    borderTop: `1px solid ${theme.custom.grey[600]}`,
                }}
            >
                <Stack width="100%" gap={theme.spacing(2)} padding={theme.spacing(4)}>
                    {recalculatePost.isLoading ?
                        <Stack alignItems="center">
                            <CircularProgress size={24} />
                        </Stack>
                    :   <Button variant="primary" onClick={handleOkClick}>
                            {t("common.ok", "OK")}
                        </Button>
                    }
                </Stack>
            </DialogActions>
        </Dialog>
    );
};
